import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getReviewOptions } from '@/module/Author/Review';
import { ReviewEdit } from '@/module/Author/Review/ReviewEdit';

export const Route = createFileRoute('/_auth/author/_author/review/_review/$reviewId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { reviewId } = Route.useParams();
  const { data: review } = useSuspenseQuery(getReviewOptions(reviewId));

  return <ReviewEdit review={review} />;
}
